
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IContact, IGroup } from '@/types/types';

@Component({ name: 'AssignGroupDialog' })
export default class AssignGroupDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => ({}) }) contact!: IContact & {
    groupContactsId?: Array<{ groupId: IGroup }>;
  };
  @Prop({ default: () => [] }) groups!: ReadonlyArray<IGroup>;

  selection: number[] = [];

  /* a fresh pick each time the dialog opens for a different contact */
  @Watch('state')
  onStateChange(open: boolean): void {
    if (open) {
      this.selection = [];
    }
  }

  get initial(): string {
    return (this.contact?.name ?? '?').charAt(0);
  }

  get currentGroups(): IGroup[] {
    return (this.contact?.groupContactsId ?? [])
      .map((entry) => entry?.groupId)
      .filter(Boolean);
  }

  /** never offer a group the contact already belongs to */
  get availableGroups(): IGroup[] {
    const assigned = this.currentGroups.map((group) => group.id);
    return (this.groups ?? []).filter(
      (group) => !assigned.includes(group.id)
    ) as IGroup[];
  }

  @Emit('actions')
  close(): { idx: string; state: boolean } {
    return { idx: 'assign', state: false };
  }

  @Emit('assign')
  assign(): { id: number; groups: number[] } {
    return { id: this.contact?.id as number, groups: this.selection };
  }
}
